var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1748677363151,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11179,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.297 523.333c-63.414 64.02-122.659 127.098-201.54 171.917 8.271-4.708 19.872-71.921 22.595-83.252 7.666-32.211 13.584-65.062 26.966-95.592 39.374-90.11 135.166-166.2 223.596-204.362 73.266-31.573 165.158-43.072 225.109-99.66-29.69 40.583-25.722 97.508-28.345 145.118-7.734 141.287-92.465 292.793-234.994 333.779-68.895 19.805-146.767 28.647-218.519 20.578 34.43-13.112 62.943-36.313 96.23-50.099 59.245-24.579 119.498-34.061 168.118-81.772-42.567 21.016-84.9 22.797-129.451 34.263 18.089-26.125 50.166-59.177 78.14-75.72 19.637-11.634 46.603-21.183 67.954-31.472 31.908-15.366 61.229-39.877 88.665-55.042-38.197 22.023-83.856 35.305-125.954 47.914 62.271-54.201 104.502-123.633 162.737-180.558-35.472 34.8-83.722 52.419-121.447 84.328-38.801 32.817-63.446 82.78-99.86 119.632z",
    fill: "#BFCD36",
    "p-id": 11180
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf1);
export default __webpack_public_path__ + "static/media/leaf1.75ebf62b3673af5acebb41a1a3260f43.svg";
export { ForwardRef as ReactComponent };